module.exports = __webpack_public_path__ + "media/images/logos/c-map-logo-light-cc77d33817a5c6c9929c60a1b498626c.png";